import { useContext, useCallback } from 'react';

import { ToastDispatchContext } from './context';
import { type ToastType } from './types';

type AddToastArgs = {
    toast: ToastType;
    toastAction?: string;
};

function useToasts(): {
    addToast: (args: AddToastArgs) => void;
} {
    const dispatch = useContext(ToastDispatchContext);

    const addToast = useCallback(
        ({ toast, toastAction }: AddToastArgs) => {
            dispatch({ type: 'ADD_TOAST', toast, toastAction });
        },
        [dispatch]
    );

    return { addToast };
}

export { useToasts };
